import { createMuiTheme } from "@material-ui/core/styles"

const theme = createMuiTheme({
  typography: {
    useNextVariants: true,
  },
  palette: {
    primary: {
      light: "#1f1f1f",
      main: "#0a0a0a",
      dark: "#000000",
      contrastText: "#fff",
    },
    secondary: {
      light: "#5b9bd5",
      main: "#357bbf",
      dark: "#2a6296",
      contrastText: "#fff",
    },
  },
  overrides: {
    MuiTabs: {
      root: {
        borderBottom: "1px solid #e5e5e5",
      },
    },
    MuiCheckbox: {
      root: {
        padding: "4px 8px",
      },
    },
    MuiRadio: {
      root: {
        padding: "4px 8px",
      },
    },
    MuiSwitch: {
      switchBase: {
        height: "36px",
      },
    },
    MuiFormControl: {
      root: {
        minWidth: "256px",
      },
    },
  },
  props: {
    MuiPaper: {
      elevation: 1,
    },
    MuiFormControl: {
      margin: "dense",
    },
    MuiInputLabel: {
      margin: "dense",
    },
    MuiInputBase: {
      margin: "dense",
    },
  },
})

export default theme
